export const server = {
  baseURL: "/api/",
};
